import axios from 'axios';

// Use relative URL in production, localhost in development
const getApiBaseUrl = () => {
  // If REACT_APP_API_URL is set, use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // In production (when not on localhost), use relative URL
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    return '/api';
  }
  
  // In development, use localhost
  return 'http://localhost:8000/api';
};

const API_BASE_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Add response interceptor to handle errors without causing page reloads
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Prevent any redirects or page reloads on API errors
    // Just return the error without causing navigation
    if (error.response) {
      // Server responded with error status
      return Promise.reject(error);
    } else if (error.request) {
      // Request was made but no response received
      console.error('Network error - API not reachable:', error.request);
      return Promise.reject(error);
    } else {
      // Something else happened
      console.error('Request setup error:', error.message);
      return Promise.reject(error);
    }
  }
);

// Add request interceptor to prevent redirects
api.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const calculatorAPI = {
  calculateSalary: async (grossPay) => {
    const response = await api.post('/calculators/salary', { grossPay });
    return response.data;
  },

  calculateTBill: async (faceValue, yieldRate, tenor) => {
    const response = await api.post('/calculators/treasury-bill', {
      faceValue,
      yieldRate,
      tenor: parseInt(tenor)
    });
    return response.data;
  },

  calculateCompound: async (principal, interestRate, years) => {
    const response = await api.post('/calculators/compound-interest', {
      principal,
      interestRate,
      years: parseFloat(years)
    });
    return response.data;
  }
};

export default api;
